import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

interface SessionsChartProps {
  data: ReadonlyArray<{ day: string; sessions: number; completions: number }>;
}

const AXIS = { fontSize: 11, fill: '#98a2b3' };

/** Measured sessions against completions — the loop's headline signal. */
export function SessionsChart({ data }: SessionsChartProps) {
  if (data.length === 0) {
    return <p className="chart-empty">Aucune session mesurée sur la période.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={228}>
      <AreaChart data={[...data]} margin={{ top: 6, right: 6, bottom: 0, left: -14 }}>
        <defs>
          <linearGradient id="grad-sessions" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5b4ee9" stopOpacity={0.22} />
            <stop offset="100%" stopColor="#5b4ee9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="grad-completions" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#1fc7bd" stopOpacity={0.22} />
            <stop offset="100%" stopColor="#1fc7bd" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid stroke="#eaedf1" vertical={false} />
        <XAxis
          dataKey="day"
          tick={AXIS}
          tickLine={false}
          axisLine={false}
          tickFormatter={shortDay}
          minTickGap={24}
        />
        <YAxis tick={AXIS} tickLine={false} axisLine={false} width={44} />
        <Tooltip
          contentStyle={{
            border: '1px solid #eaedf1',
            borderRadius: 10,
            boxShadow: '0 8px 28px rgba(16,24,40,.1)',
            fontSize: 12,
          }}
          labelFormatter={shortDay}
        />

        <Area
          type="monotone"
          dataKey="sessions"
          name="Sessions"
          stroke="#5b4ee9"
          strokeWidth={2}
          fill="url(#grad-sessions)"
        />
        <Area
          type="monotone"
          dataKey="completions"
          name="Achèvements"
          stroke="#1fc7bd"
          strokeWidth={2}
          fill="url(#grad-completions)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

function shortDay(day: string): string {
  const date = new Date(day);
  return Number.isNaN(date.getTime())
    ? day
    : date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
}
